import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { PreFlights } from 'pupdocs/pages/preFlights/PreFlights';
import { FileDetails } from 'pupdocs/pages/fileDetails/FileDetails';
import { PupDocsRoutes } from 'pupdocs/utilities/const';
import { useUserCapabilities } from 'shared/hooks';
import { UserCapabilities } from 'utilities/const';

export const PupDocs = (): ReactElement | null => {
  const { capabilities, loadingCapabilities } = useUserCapabilities();

  if (loadingCapabilities) return null;

  return capabilities.includes(UserCapabilities.UsePupDocsApp) ? (
    <Switch>
      <Route path={PupDocsRoutes.PreFlight} component={PreFlights} />
      <Route path={`${PupDocsRoutes.FileDetails}/:lineItemId`} component={FileDetails} />
    </Switch>
  ) : (
    <Switch>
      <Redirect to="/dashboard" />
    </Switch>
  );
};
